import { useReportingContext } from 'modules/iterableGoals/contexts';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { MediumEnum, MediumMetric } from 'modules/iterableGoals/types';
import { getMediumLabel } from 'modules/iterableGoals/utils';
import { localizeCurrencyValue } from 'utils/i18nHelpers';

import { localize } from 'utils/numberHelpers';
import { ChannelRow, ChartLabels, MediumColorIndicator, MediumLabel, SendsCount } from './Styled';

type MediumMetricsRowProps = {
  color: string;
  icon: JSX.Element;
  medium: MediumEnum;
  mediumData: MediumMetric;
  sends: number;
};

export const MediumMetricsRow = ({
  mediumData,
  sends,
  icon,
  medium,
  color,
}: MediumMetricsRowProps) => {
  const { t, ct } = useGoalsTranslations();
  const { isRevenue } = useReportingContext();
  const value = isRevenue ? localizeCurrencyValue(mediumData.value) : localize(mediumData.value);

  return (
    <ChannelRow>
      <ChartLabels>
        <MediumColorIndicator color={color} />
        {icon}
        <MediumLabel>{getMediumLabel(ct, medium)}</MediumLabel>
        <SendsCount>
          {t('labels.goalContributionsByMedium.sends', { count: sends, label: localize(sends) })}
        </SendsCount>
      </ChartLabels>

      <MediumLabel>{localize(value)}</MediumLabel>
    </ChannelRow>
  );
};
